module.exports = __webpack_public_path__ + "img/footer-logo.be179dae.png";